(function(w, $) {
	let slider;

	function navigation() {
		const $menuItem = $(this);

		if (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0)) {
			$menuItem.find('a').on('click', function(e) {
				const $thisItem = $(this);

				if ($thisItem.next('.sub-menu').length) {
					e.preventDefault();

					$thisItem
						.toggleClass('menu-item__link--active').next('.sub-menu').toggleClass('sub-menu--active')
						.closest('li').toggleClass('menu-item--active')
						.siblings().removeClass('menu-item--active')
						.find('.menu-item__link--active')
						.removeClass('menu-item__link--active')
						.next('.sub-menu--active').removeClass('sub-menu--active');
				} else {
					return true;
				}
			});
		} else {
			$menuItem.on('mouseover', function() {
				$(this).addClass('menu-item--active').find('.sub-menu').addClass('sub-menu--active');
			}).on('mouseout', function() {
				$(this).removeClass('menu-item--active').find('.sub-menu').removeClass('sub-menu--active');
			});
		}
	}

	function mobileNavigation() {
		$(this).on('click', function() {
			const $navicon = $(this);

			$navicon.toggleClass('site-header__navicon--active').closest('body').toggleClass('body__site-navigation--active').find('.site-navigation').toggleClass('site-navigation--active');
			$navicon.closest('body').find('.site-header__overlay').toggleClass('site-header__overlay--active');
		});
	}

	function accordions() {
		$(this).on('click', function() {
			$(this).toggleClass('rank-math-question--active').next('.rank-math-answer').stop().slideToggle(function() {
				$(this).closest('.rank-math-list-item').siblings().find('.rank-math-question--active').removeClass('rank-math-question--active');
				$(this).closest('.rank-math-list-item').siblings().find('.rank-math-answer').stop().slideUp();
				$(this).parent().siblings().toggleClass('rank-math-list-item--inactive');
			});
		});
	}

	function partnerAccordions() {
		$(this).on('click', function() {
			$(this).toggleClass('site-partnerships-listing__accordion-heading--active').next('.site-partnerships-listing__accordion-content').stop().slideToggle(function() {
				if ($(this).is(':visible')) {
					$(this).css('display', 'flex');
				}
				$(this).closest('.site-partnerships-listing__accordion-item').siblings().find('.site-partnerships-listing__accordion-heading--active').removeClass('site-partnerships-listing__accordion-heading--active');
				$(this).closest('.site-partnerships-listing__accordion-item').siblings().find('.site-partnerships-listing__accordion-content').stop().slideUp();
				$(this).parent().siblings().toggleClass('site-partnerships-listing__accordion-item--inactive');
			});
		});
	}

	function testimonialSlider() {
		slider = tns({
			container: '.testimonial-slider',
			items: 1,
			slideBy: 'page',
			autoplay: true,
			mouseDrag: true,
			autoHeight: true,
			controls: false,
			navPosition: 'bottom',
			lazyload: true,
			autoplayButtonOutput: false
		});
	}

	function memberTiersSlider() {
		slider = tns({
			container: '.site-membership-tiers__list',
			items: 4,
			slideBy: 'page',
			autoplay: true,
			mouseDrag: true,
			autoHeight: true,
			controls: false,
			navPosition: 'bottom',
			lazyload: true,
			autoplayButtonOutput: false
		});
	}

	function partnersSlider() {
		const statusSpan = document.querySelector('.site-partnerships-listing__slider-title-status');
		let numberOfItems = 5;

		if (statusSpan) {
			numberOfItems = 4;
		}

		slider = tns({
			container: $(this)[ 0 ],
			items: numberOfItems,
			loop: false,
			slideBy: 'page',
			autoplay: 6000,
			mouseDrag: true,
			autoHeight: true,
			controls: false,
			navPosition: 'bottom',
			lazyload: true,
			autoplayButtonOutput: false,
			responsive: {
				'0': { 'items': 2 },
				'640': { 'items': 3 },
				'1024': { 'items': numberOfItems }
			}
		});

		if (statusSpan) {
			const items = document.querySelectorAll('.site-partnerships-listing__slider-content-item');

			function updateStatusHeading() {
				const sliderInfo = slider.getInfo();
				const visibleStatuses = [];
				const startIndex = sliderInfo.index;
				const endIndex = startIndex + sliderInfo.items;

				for (let i = startIndex; i < endIndex; i ++) {
					const item = items[ i % items.length ]; // Ensure index is within bounds for looping sliders
					const statusHeading = item.getAttribute('data-status-heading');
					if (!visibleStatuses.includes(statusHeading)) {
						visibleStatuses.push(statusHeading);
					}
				}

				if (visibleStatuses.length > 1) {
					const lastStatus = visibleStatuses.pop();
					statusSpan.textContent = visibleStatuses.join(', ') + ' & ' + lastStatus;
				} else {
					statusSpan.textContent = visibleStatuses.join(', ');
				}
			}

			slider.events.on('indexChanged', updateStatusHeading);

			updateStatusHeading();
		}
	}

	function truncate() {
		const $element = $(this);
		const $elementObj = $element[ 0 ];

		if ($elementObj.offsetHeight < $elementObj.scrollHeight || $elementObj.offsetWidth < $elementObj.scrollWidth) {
			$element.addClass('testimonial__block-text--truncated');
			$element.siblings('.testimonial__block-text-toggle').first().addClass('testimonial__block-text-toggle--show');
		} else {
			$element.removeClass('testimonial__block-text--truncated');
			$element.siblings('.testimonial__block-text-toggle').first().removeClass('testimonial__block-text-toggle--show');
		}

		$element.siblings('.testimonial__block-text-toggle').on('click', function(e) {
			const $button = $(this);

			e.preventDefault();
			$button.add($button.siblings()).toggleClass('testimonial__block-text-toggle--show');
			$button.prevAll('.testimonial__block-text').toggleClass('testimonial__block-text--reveal');
			slider.updateSliderHeight();
		});
	}

	function smoothScroll() {
		$(this).on('click', function(e) {
			e.preventDefault();

			$('html, body').animate({
				scrollTop: $($.attr(this, 'href')).offset().top
			}, 500);
		});
	}

	$(document).ready(function() {
		$('.site-navigation').find('.menu-item').each(navigation);
		$('.site-header__navicon').each(mobileNavigation);

		$('.rank-math-question').each(accordions);
		$('.site-partnerships-listing__accordion-heading').each(partnerAccordions);

		$('a[href^="#"]').each(smoothScroll);

		$('.testimonial__block-text').each(truncate);
		$('.testimonial-slider').each(testimonialSlider);
		$('.site-partnerships-listing__slider-content').each(partnersSlider);
		$('.site-membership-tiers__list').each(memberTiersSlider);
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
}(window, jQuery));
